var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBaseball = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipPath: "url(#baseball_svg__a)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.32 13.677A8.03 8.03 0 1 0 13.678 2.321 8.03 8.03 0 0 0 2.321 13.677m10.65-.707a7.03 7.03 0 1 1-9.942-9.942 7.03 7.03 0 0 1 9.942 9.942"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.502 14.648a.5.5 0 0 0 .11-.698c-2.575-3.53-2.539-8.314.15-11.78a.5.5 0 0 0-.79-.613C9.007 5.38 8.97 10.653 11.804 14.54a.5.5 0 0 0 .698.11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.463 11.962a.5.5 0 0 0 .628.325l1.806-.573a.5.5 0 0 0-.302-.953l-1.806.573a.5.5 0 0 0-.326.628m2.715-6.802a.5.5 0 0 0-.214-.674l-1.682-.872a.5.5 0 0 0-.46.888l1.682.872a.5.5 0 0 0 .674-.214m-8.842 9.38a.5.5 0 0 0 .701-.089 10.82 10.82 0 0 0 .19-13.013.5.5 0 1 0-.808.59 9.82 9.82 0 0 1-.172 11.81.5.5 0 0 0 .089.702"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.808 4.89a.5.5 0 0 0 .627.325l1.806-.573a.5.5 0 0 0-.302-.954l-1.806.574a.5.5 0 0 0-.325.628m2.614 7.258a.5.5 0 0 0-.214-.674l-1.682-.872a.5.5 0 1 0-.46.888l1.682.872a.5.5 0 0 0 .674-.214M4.145 8.152a.5.5 0 0 0 .5.5h2.149a.5.5 0 0 0 0-1h-2.15a.5.5 0 0 0-.5.5m4.372 0a.5.5 0 0 0 .5.5h2.15a.5.5 0 1 0 0-1h-2.15a.5.5 0 0 0-.5.5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "baseball_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgBaseball;